import React, { useState, useEffect, useRef } from 'react';
import * as styles from './styles.module.scss';

const CountrySwitcher = () => {
  const [showSelector, setShowSelector] = useState(false);

  function useOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowSelector(false);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }

  function toggleSelectDisplay() {
    const state = showSelector;
    setShowSelector(!state);
  }

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef);

  return (
    <div className={styles.selectorWrapper} ref={wrapperRef}>
      {showSelector && (
        <div className={styles.dropdownSelector}>
          <ul>
            <li>
              <a href="https://drivafinance.co.uk">🇬🇧 United Kingdom</a>
            </li>
            <li>
              <a href="https://driva.com.au">🇦🇺 Australia</a>
            </li>
            <li onClick={toggleSelectDisplay}>🇳🇿 New Zealand &#10003;</li>
          </ul>
        </div>
      )}
      <p className={styles.currentCountry} onClick={toggleSelectDisplay}>
        🇳🇿 New Zealand
      </p>
    </div>
  );
};

export default CountrySwitcher;
